@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import com.happyukrainian.revision.kweb.pages.FlashcardPage as _com_happyukrainian_revision_kweb_pages_FlashcardPage
import com.happyukrainian.revision.kweb.pages.HomePage as _com_happyukrainian_revision_kweb_pages_HomePage
import com.happyukrainian.revision.kweb.pages.MaterialPage as _com_happyukrainian_revision_kweb_pages_MaterialPage
import com.happyukrainian.revision.kweb.pages.TopicPage as _com_happyukrainian_revision_kweb_pages_TopicPage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Happy Ukrainian Revision"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_happyukrainian_revision_kweb_pages_HomePage()
        }
        ctx.router.register(
            "/subject/{subject}/topic/{topic}/flashcards",
        ) { pageCtx -> 
            _com_happyukrainian_revision_kweb_pages_FlashcardPage()
        }
        ctx.router.register(
            "/subject/{subject}/topic/{topic}/materials",
        ) { pageCtx -> 
            _com_happyukrainian_revision_kweb_pages_MaterialPage()
        }
        ctx.router.register(
            "/subject/{subject}/topics",
        ) { pageCtx -> 
            _com_happyukrainian_revision_kweb_pages_TopicPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("flip-container", com.happyukrainian.revision.kweb.config.FlipContainerStyle)
        ctx.theme.registerStyle("button", com.happyukrainian.revision.kweb.config.ButtonStyle)
        ctx.theme.registerKeyframes("flip-out", com.happyukrainian.revision.kweb.components.FlipOutAnimation)
        ctx.theme.registerKeyframes("flip-in", com.happyukrainian.revision.kweb.components.FlipInAnimation)
        ctx.theme.registerKeyframes("flip-back-in", com.happyukrainian.revision.kweb.components.FlipBackInAnimation)
        ctx.theme.registerKeyframes("flip-back-out", com.happyukrainian.revision.kweb.components.FlipBackOutAnimation)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.happyukrainian.revision.kweb.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
